import axios from '../../plugins/axios'

export const actions = {
    listaResultados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`tipos-resultados` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listarResultadosGeral(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`tipos-resultados`)
                .then(response => {
                    const data = response.data.map((item) => {
                        return {
                            value: item.id,
                            text: item.titulo
                        }
                    });
                    resolve(data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listaResultadosPorId(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`tipos-resultados/${payload}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    adicionaResultado(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`tipos-resultados/adicionar`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    atualizaResultado(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put(`tipos-resultados/${payload.id}`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/tiposresultados.js